<template>
  <div>
    <b-table-simple small borderless class="mb-0">
      <b-tbody>
        <b-tr v-if="event.reservation && user.is_admin">
          <b-td>ID:</b-td>
          <b-td class="text-muted">{{ event.reservation.id }}</b-td>
        </b-tr>
        <b-tr>
          <b-td>Termin:</b-td>
          <b-th>{{ formatDate(item.date_string) }}</b-th>
        </b-tr>
        <b-tr>
          <b-td>Fryzjer:</b-td>
          <b-th>{{ event.barber.name }}</b-th>
        </b-tr>
        <b-tr>
          <b-td>Usługa:</b-td>
          <b-th>
            <span
              v-if="!event.reservation"
              class="text-success"
            >
              niezarezerwowane
            </span>
            <span
              v-else-if="!event.reservation.is_blocked"
              v-html="event.reservation.service.name_html"
            />
            <span
              v-else-if="event.reservation.is_blocked"
              class="text-danger"
            >
              zablokowane
            </span>
          </b-th>
        </b-tr>
        <template v-if="event.reservation && !event.reservation.is_blocked">
          <b-tr v-if="event.reservation.contact">
            <b-td>Kontakt:</b-td>
            <b-th>
              {{ event.reservation.contact.name }}
            </b-th>
          </b-tr>
          <b-tr>
            <b-td>Telefon:</b-td>
            <b-th>
              <b-link :href="`tel:${event.reservation.phone_number}`" class="text-dark">
                <u>{{ event.reservation.phone_number }}</u>
                <b-icon icon="telephone-outbound-fill" class="text-muted" />
              </b-link>
            </b-th>
          </b-tr>
          <b-tr v-if="event.reservation.email">
            <b-td>Email:</b-td>
            <b-th>
              {{ event.reservation.email }}
            </b-th>
          </b-tr>
          <b-tr>
            <b-td>Status:</b-td>
            <b-th>
              <span v-if="event.reservation.is_blocked" />
              <span
                v-else-if="event.reservation.is_paid"
                class="text-success"
              >
                zapłacone
              </span>
              <span
                v-else-if="event.reservation.is_pending"
                class="text-primary"
              >
                opłacanie...
              </span>
              <span
                v-else-if="!event.reservation.is_paid"
                class="text-danger"
              >
                niezapłacone
              </span>
            </b-th>
          </b-tr>
          <b-tr>
            <b-td>Kod:</b-td>
            <b-th>
              {{ event.reservation.code }}
            </b-th>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import DateFormat from '@/Mixins/DateFormat'

export default {
  mixins: [DateFormat],
  props: {
    item: Object,
    event: Object,
  },
  computed: {
    user() {
      return this.$page.props.auth.user
    },
  },
}
</script>
